import { render } from "./NoOrder.vue?vue&type=template&id=d21131b6"
import script from "./NoOrder.vue?vue&type=script&lang=js"
export * from "./NoOrder.vue?vue&type=script&lang=js"

import exportComponent from "D:\\POS 22\\pawhouse\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__